import { render, staticRenderFns } from "./PlansIntro.vue?vue&type=template&id=02305458&lang=pug"
import script from "./PlansIntro.vue?vue&type=script&lang=js"
export * from "./PlansIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports